import React from 'react';
import { Banner } from '../../../../models';
import styles from '../ModalBanner.module.scss';

type Props = {
    banner: Banner;
    onClick: () => void;
    previewMode?: boolean;
}

const ModalImageContent: React.FC<Props> = ({ banner, onClick, previewMode }) => {
    const isClickable = !previewMode && !!banner.bannerLink;

    return (
        <div className={styles.imageOnly}>
            <div
                className={styles.imageLink}
                onClick={onClick}
                style={{ cursor: isClickable ? 'pointer' : 'default' }}
            >
                <img src={banner.imageUrl!} alt={banner.title} className={styles.image} />
            </div>
        </div>
    );
};

export default ModalImageContent;
